'use client';
import React from 'react';
import Link from 'next/link';

interface OrganizerBannerProps {
  variant?: 'finder' | 'organizer';
}

export default function OrganizerBanner({ variant = 'organizer' }: OrganizerBannerProps) {
  if (variant === 'finder') {
    return (
      <div style={{ margin: '0 48px', marginBottom: '16px' }}>
        <div
          className="overflow-hidden relative"
          style={{ background: '#F5EFE6', borderRadius: '16px', border: '1px solid rgba(201,168,76,0.2)' }}>
          
          <div className="flex flex-col md:flex-row items-center">
            {/* Left: Image */}
            <div className="relative flex-shrink-0" style={{ width: '280px', height: '220px' }}>
              <img
                src="https://images.unsplash.com/photo-1513908957990-b2790723edbf"
                alt="Person browsing events on smartphone with event recommendations displayed"
                className="w-full h-full object-cover"
                style={{ borderRadius: '16px 0 0 16px' }} />
              
            </div>
            {/* Right: Text */}
            <div className="flex-1 p-8 md:p-10">
              <h2
                className="text-2xl font-bold mb-2"
                style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#1A0A00' }}>
                
                Event Finder
              </h2>
              <p className="text-sm mb-5" style={{ color: '#8B7355', fontFamily: 'Roboto, sans-serif' }}>
                Not sure what to attend? Answer a few quick questions and we&apos;ll match you with the perfect events.
              </p>
              <div className="flex gap-3">
                <Link
                  href="#filter"
                  className="flex items-center justify-center h-10 px-6 font-medium text-sm transition-all duration-200 hover:opacity-90"
                  style={{
                    background: 'linear-gradient(135deg, #C9A84C, #8B6914)',
                    color: '#FAF7F2',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: 500,
                    fontFamily: 'Roboto, sans-serif',
                  }}>
                  
                  Browse &amp; Filter
                </Link>
                <Link
                  href="#quiz"
                  className="flex items-center justify-center h-10 px-6 font-medium text-sm transition-all duration-200"
                  style={{
                    background: 'transparent',
                    color: '#1A0A00',
                    border: '1px solid rgba(201,168,76,0.4)',
                    borderRadius: '8px',
                    fontSize: '13px',
                    fontWeight: 500,
                    fontFamily: 'Roboto, sans-serif',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(201,168,76,0.08)')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}>
                  
                  Take the Quiz
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>);

  }

  return (
    <Link
      href="#create-event"
      className="block cursor-pointer group"
      style={{ margin: '0 48px', marginBottom: '16px' }}>
      
      <div
        className="relative overflow-hidden"
        style={{
          background: '#1A0A00',
          borderRadius: '16px',
          minHeight: '200px',
          border: '1px solid rgba(201,168,76,0.3)',
          boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
        }}>
        
        {/* Gold top accent */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(to right, transparent, #C9A84C, #E8C97A, #C9A84C, transparent)', zIndex: 20 }} />

        {/* Background Image */}
        <div className="absolute inset-0 opacity-15">
          <img
            src="https://img.rocket.new/generatedImages/rocket_gen_img_10e9d516c-1780922074661.png"
            alt="Event organizer managing large scale event with crowd"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between p-10 md:p-12 gap-6">
          <div>
            <div
              className="inline-flex items-center px-2.5 py-0.5 rounded mb-3"
              style={{ background: 'rgba(201,168,76,0.15)', borderRadius: '4px', border: '1px solid rgba(201,168,76,0.4)' }}>
              
              <span
                className="text-[11px] font-bold"
                style={{ letterSpacing: '1.5px', color: '#C9A84C', fontFamily: 'Roboto, sans-serif' }}>
                
                FOR ORGANIZERS
              </span>
            </div>
            <h2
              className="text-3xl font-bold mb-2"
              style={{ fontFamily: '"Playfair Display", Georgia, serif', color: '#E8C97A' }}>
              
              Rani Kamlapati for Organizers
            </h2>
            <p className="text-base" style={{ color: 'rgba(250,247,242,0.65)', fontFamily: 'Roboto, sans-serif' }}>
              Create, promote, and manage your events. Reach millions of attendees worldwide.
            </p>
          </div>
          <div className="flex-shrink-0">
            <span
              className="flex items-center justify-center h-12 px-8 font-medium text-base transition-all duration-200 hover:opacity-90"
              style={{
                background: 'linear-gradient(135deg, #C9A84C, #8B6914)',
                color: '#FAF7F2',
                borderRadius: '8px',
                fontSize: '15px',
                fontWeight: 500,
                fontFamily: 'Roboto, sans-serif',
                boxShadow: '0 4px 16px rgba(201,168,76,0.3)',
              }}>
              
              Start for free
            </span>
          </div>
        </div>
      </div>
    </Link>);

}